import React, { useState } from 'react'
import {
  BrowserRouter as Router,
  NavLink as RouterLink,
} from 'react-router-dom'
import {
  Flex,
  Text,
  Image,
  Box,
  Link as ChakraLink,
  Button,
  ChakraProvider,
  Card,
  CardBody,
  Stack,
  Heading,
  Divider,
  CardFooter,
  Center,
  useColorModeValue,
  useColorMode,
} from '@chakra-ui/react'
import { LinkIcon } from '@chakra-ui/icons'

const Projects = () => {
  const [project, setProject] = useState(true)
  const { colorMode, toggleColorMode } = useColorMode()
  const bg = useColorModeValue('none', 'none')
  const color = useColorModeValue('black', 'white')

  const projectDetails = [
    {
      id: 1,
      src: '/bintus store pic.jpeg',
      alt: 'bintus store',
      projectLink: '/bintusstore',
      linkButton: 'https://bintusstore.vercel.app/',
      githubLinkButton:
        'https://github.com/bintus-ux/bintus-store-frontend-site',
      name: 'Bintus Store Clothing App',
      info: 'Bintus store clothing app is a clothing store e-commerce website. Users can create accounts to enable them make instant purchases and add items to cart to purchase in bulk or later ',
      footerInfo: 'Project completed!',
    },
    {
      id: 2,
      src: '/book app.jpeg',
      alt: 'book app',
      projectLink: '/bookapp',
      name: 'Book App',
      info: 'Book app is a web application that allows registered users purchase their favorite  e-books for FREE! It allows users read,  guage progress and store for future reference',
      footerInfo: 'Project still in progress...',
    },
    {
      id: 3,
      src: '/afrotopia.png',
      alt: 'afrotopia',
      projectLink: '/afrotopia',
      linkButton: 'https://afrotopia.vercel.app/',
      githubLinkButton: 'https://github.com/bintus-ux/afrotopia-site',
      name: 'Afrotopia',
      info: 'Afrotopia is a fashion store site that allows registered users purchase their choice fits for exclusive occasions! Users are able to pick from a range of trendy outfits exhibited by fashion icons from all over the globe!',
      footerInfo: 'Project still in progress...',
    },
  ]
  const internProjectDetails = [
    {
      id: 1,
      src: '/intern project1 slide1.jpeg',
      alt: 'movie box project',
      name: 'Movie Box',
      info: 'Movie box is a web application built to make API requests to IMDB movie site database and return top rated movies which on clicking any displays the particular movie details',
      stackInfo: 'REACTJS + IMDB API',
    },
    {
      id: 2,
      src: '/intern project2 slide1.jpeg',
      alt: 'Drag & drop picture gallery',
      linkButton: 'https://stage-three-task-three.vercel.app/',
      githubLinkButton: 'https://github.com/bintus-ux/stage-three-task',
      name: 'Drag & drop picture gallery',
      info: 'Drag & drop picture gallery is a web application that allows registered users utilize the drag & drop picture functionality but doesnt for unauthorized users',
      stackInfo: 'REACTJS + CHAKRA FRAMER MOTION',
    },
    {
      id: 3,
      src: '/screenrecordextension.jpg',
      alt: 'Screen record extension',
      linkButton: 'https://stage-three-task-three.vercel.app/',
      githubLinkButton: 'https://github.com/bintus-ux/stage-three-task',
      name: 'Screen record extension',
      info: 'Screen recording chrome extension plugin',
      stackInfo: 'JAVASCRIPT + CHROME SCREEN CAPTURE API',
    },
  ]
  return (
    <ChakraProvider>
      <Box
        w={{
          base: '90%',
          sm: '90%',
          md: '90%',
          lg: '90%',
          xl: '90%',
        }}
        alignContent='center'
        mx='auto'
        h={{
          base: 'auto',
          sm: 'auto',
          md: 'auto',
          lg: 'auto',
          xl: 'auto',
        }}>
        <Box>
          <Center>
            <Box className='projects-category'>
              <Button
                onClick={() => setProject(true)}
                borderRadius='none'
                _hover={{ bg: 'none' }}
                borderBottom={project && '2px solid olive'}
                fontSize={{
                  base: '19px',
                  sm: '19px',
                  md: '35px',
                  lg: '35px',
                  xl: '40px',
                }}
                color={color}
                bg={bg}
                fontFamily='Inter'
                letterSpacing={{
                  base: '2px',
                  sm: '2px',
                  md: '5px',
                  lg: '5px',
                  xl: '5px',
                }}
                mt={{
                  base: '10px',
                  sm: '10px',
                  md: '50px',
                  lg: '50px',
                  xl: '50px',
                }}>
                {' '}
                Projects
              </Button>

              <Button
                onClick={() => setProject(false)}
                borderRadius='none'
                py={5}
                _hover={{ bg: 'none' }}
                borderBottom={!project && '2px solid olive'}
                color={color}
                bg={bg}
                fontSize={{
                  base: '19px',
                  sm: '19px',
                  md: '35px',
                  lg: '35px',
                  xl: '40px',
                }}
                fontFamily='Inter'
                letterSpacing={{
                  base: '2px',
                  sm: '2px',
                  md: '5px',
                  lg: '5px',
                  xl: '5px',
                }}
                mt={{
                  base: '10px',
                  sm: '10px',
                  md: '50px',
                  lg: '50px',
                  xl: '50px',
                }}>
                {' '}
                Internship Projects
              </Button>
              {/* </Link> */}
            </Box>
          </Center>
          <Center>
            <Text
              fontSize={{
                base: '15px',
                sm: '15px',
                md: '25px',
                lg: '25px',
                xl: '25px',
              }}
              fontFamily='Indie Flower'
              letterSpacing='5px'
              mb={{
                base: '30px',
                sm: '30px',
                md: '50px',
                lg: '100px',
                xl: '100px',
              }}
              mt={{
                base: '10px',
                sm: '10px',
                md: '50px',
                lg: '30px',
                xl: '30px',
              }}>
              {' '}
              Below are some of my projects, be it completed or ongoing,
              designed and built through sheer intellect & perseverance...
            </Text>
          </Center>
          {project ? (
            <Flex
              direction={{
                base: 'column',
                sm: 'column',
                md: 'row',
                lg: 'row',
                xl: 'row',
              }}
              gap='30px'
              w='auto'>
              {projectDetails.map((projectDetail) => (
                <Card className='card' maxW='sm' key={projectDetail.id}>
                  <CardBody>
                    <ChakraLink href={projectDetail.projectLink}>
                      <Image
                        className='card-img'
                        src={projectDetail.src}
                        alt={projectDetail.alt}
                        borderRadius='lg'
                      />
                    </ChakraLink>
                    <Stack className='card-content' mt='6' spacing='3'>
                      <Heading size='md'>{projectDetail.name}</Heading>
                      <Text>{projectDetail.info}</Text>
                      <ChakraLink
                        className='in-depth-click'
                        href={projectDetail.projectLink}>
                        <Text color='olive' fontSize='xl'>
                          Click me to see in-depth details
                        </Text>
                      </ChakraLink>
                    </Stack>
                  </CardBody>
                  <Divider />
                  <CardFooter
                    display='flex'
                    justifyContent='space-between'
                    alignItems='center'>
                    <Text
                      color='blue.600'
                      fontSize='2xl'
                      fontFamily='Shadows Into Light'>
                      {projectDetail.footerInfo}
                    </Text>
                    <div
                      style={{
                        width: '50px',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}>
                      <a href={projectDetail.linkButton} target='_blank'>
                        <LinkIcon />
                      </a>{' '}
                      <a href={projectDetail.githubLinkButton} target='_blank'>
                        <i className='fa-brands fa-github fa-lg' />
                      </a>
                    </div>
                  </CardFooter>
                </Card>
              ))}
            </Flex>
          ) : (
            <Flex
              direction={{
                base: 'column',
                sm: 'column',
                md: 'row',
                lg: 'row',
                xl: 'row',
              }}
              gap='30px'
              w='auto'>
              {internProjectDetails.map((projectDetail) => (
                <Card className='card' maxW='sm' key={projectDetail.id}>
                  <CardBody>
                    <ChakraLink href={projectDetail.projectLink}>
                      <Image
                        className='card-img'
                        src={projectDetail.src}
                        alt={projectDetail.alt}
                        borderRadius='lg'
                      />
                    </ChakraLink>
                    <Stack className='card-content' mt='6' spacing='3'>
                      <Heading size='md'>{projectDetail.name}</Heading>
                      <Text>{projectDetail.info}</Text>
                    </Stack>
                  </CardBody>
                  <Divider />
                  <CardFooter
                    display='flex'
                    justifyContent='space-between'
                    alignItems='center'>
                    <Text
                      color='blue.600'
                      fontSize='xs'
                      fontFamily='inter'
                      maxWidth='250px'>
                      {projectDetail.stackInfo}{' '}
                    </Text>
                    <div
                      style={{
                        width: '50px',
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}>
                      <a href={projectDetail.linkButton} target='_blank'>
                        <LinkIcon />
                      </a>{' '}
                      <a href={projectDetail.githubLinkButton} target='_blank'>
                        <i className='fa-brands fa-github fa-lg' />
                      </a>
                    </div>
                  </CardFooter>
                </Card>
              ))}
            </Flex>
          )}
        </Box>
      </Box>
    </ChakraProvider>
  )
}

export default Projects
